export const NEW_WINDOW = '_blank'
export const DATA_TEST_ID = 'link-button'
export const FEEDBACK_LINK_DATA_TEST_ID = 'lesson-complete-feedback-link'
